import { WebpPattern } from "../assets";

let megaMenuList = [
  {
    title: "Home",
    link: "/",
    children: [
      {
        title: "Home",
        titleLink: "/",
        img: WebpPattern,
        content:
          "At Knights Home Service, we pride ourselves on offering expert appliance repair services that you can trust. Our team of skilled technicians is dedicated to delivering efficient and transparent repairs for your refrigerator. Learn more about our pricing and commitment to exceptional service.",
        contentLink: "/",
      },
    ],
  },
  {
    title: "Services",
    link: "/services",
    children: [
      {
        title: "window cleaning",
        titleLink: "/services",
        img: WebpPattern,
        content:
          "At Knights Home Service, we provide professional window cleaning that leaves your windows spotless, streak-free, and shining like new.",
        contentLink: "/services",
      },
      {
        title: "House washing",
        titleLink: "/services",
        img: WebpPattern,
        content:
          "Our professional house washing removes dirt, grime, and mildew, restoring your home’s curb appeal and protecting its surfaces. Experience a thorough, safe, and eco-friendly clean every time!",
        contentLink: "/services",
      },
      {
        title: "Roof Cleaning",
        titleLink: "/services",
        img: WebpPattern,
        content:
          "Our professional roof cleaning removes algae, moss, and debris, extending the life of your roof while enhancing its appearance. Trust us for a safe, thorough, and long-lasting clean!",
        contentLink: "/services",
      },
      {
        title: "Gutter Cleaning",
        titleLink: "/services",
        img: WebpPattern,
        content:
          "Our professional gutter cleaning removes leaves, debris, and buildup to prevent clogs and protect your home from water damage. Reliable, efficient, and hassle-free service every time!",
        contentLink: "/services",
      },
    ],
  },
  {
    title: "About Us",
    link: "#",
    children: [
      {
        title: "About Us",
        titleLink: "#",
        img: WebpPattern,
        content:
          "At Knights Home Service, we are dedicated to providing top-quality cleaning solutions for your home and property. With a focus on professionalism, reliability, and customer satisfaction, we deliver services you can trust to keep your space looking its best!",
        contentLink: "#",
      },
    ],
  },

  {
    title: "Contact Us",
    link: "/contactus",
    children: [
      {
        title: "Contact Us",
        titleLink: "/contactus",
        img: WebpPattern,
        content:
          "At Knights Home Service, we pride ourselves on offering expert appliance repair services that you can trust. Our team of skilled technicians is dedicated to delivering efficient and transparent repairs for your refrigerator. Learn more about our pricing and commitment to exceptional service.",
        contentLink: "/contactus",
      },
    ],
  },
  {
    title: "Gallery",
    link: "/gallery",
    children: [
      {
        title: "Gallery",
        titleLink: "/gallery",
        img: WebpPattern,
        content:
          "At Knights Home Service, we pride ourselves on offering expert appliance repair services that you can trust. Our team of skilled technicians is dedicated to delivering efficient and transparent repairs for your refrigerator. Learn more about our pricing and commitment to exceptional service.",
        contentLink: "/gallery",
      },
    ],
  },
];

export { megaMenuList };
